import { Injectable } from '@angular/core';

import { Lookup, LookupDoc, lookupMethods, lookupSchema } from '../schema/lookup-schema';
import { AppState } from '../app-state';

import { UserRole } from '../models/user';
import { TestbedRxdbCouchCollectionService } from './testbed-rxdb/testbed-rxdb-couch-collection.service';
import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class LookupService extends TestbedRxdbCouchCollectionService<Lookup,LookupDoc>{

    constructor( appState : AppState, rxdbState: TestbedRxdbState, authService: AuthenticationService) { 
        super('lookup', lookupSchema, appState, rxdbState, authService )
        this.syncConfig = {
            push: false,
            pull: true,
            intervalMs: this.appState.settings.get('rxdb.collections.lookup.intervalMs',0),
            retry: true
        }
        this.methods = lookupMethods
    }


    async getRoles() : Promise<UserRole[]>  {
        //const lookups = await this.rxCollection.find().exec()
        //lookups.forEach(lookup => JSON.stringify(lookup.toJSON()))
        const roleDoc : LookupDoc = await this.rxCollection.findOne('roles').exec()
        
        const bRolesSyncedAndFound = roleDoc != null
        if ( !bRolesSyncedAndFound ) {
            return []
        }
        
        return roleDoc?.values.map( role => new UserRole(role.id,role.name,role.permissions) )
    }

}